import { fetch } from 'http-common';
import SockJS from 'sockjs-client';
import Stomp, { Frame } from 'stompjs';

import { tokenStore } from 'lib/tokenStore';

import { MessageType } from 'types/api/message.type';

type Recipient = {
  id: string;
  name: string;
};

class MessagesDataService {
  constructor(public customer: Recipient, public user: Recipient) {}

  private url = process?.env?.REACT_APP_API_URL;

  // eslint-disable-next-line class-methods-use-this
  private get token() {
    return tokenStore.getAccessToken();
  }

  private http = fetch();

  private stompClient: Stomp.Client | null = null;

  onConnected(callback: (message: MessageType) => void) {
    this.stompClient!.subscribe(`/topic/messages/${this.customer.id}`, (msg) =>
      this.onMessage(msg, callback)
    );
  }

  static onError(err: string | Frame) {
    throw err;
  }

  fetchAllMessages() {
    return this.http.get(`/v1/messages/${this.customer.id}?appName=CATALOGUE`);
  }

  // eslint-disable-next-line
  onMessage(message: any, callback: (arg: MessageType) => void) {
    callback(JSON.parse(message.body));
  }

  send(msg: string) {
    if (msg.trim() !== '' && this.customer && this.user) {
      const message = {
        senderId: this.user.id,
        senderName: this.user.name,
        recipientId: this.customer.id,
        recipientName: this.customer.name,
        content: msg,
        timestamp: new Date(),
      };

      this.stompClient!.send(
        `/app/chat/${this.customer.id}/CATALOGUE`,
        {},
        JSON.stringify(message)
      );
    }
  }

  async init(callback: (message: MessageType) => void) {
    const sock = new SockJS(`${this.url}/chat?token=${this.token}`);
    this.stompClient = Stomp.over(sock);

    this.stompClient.connect(
      {},
      () => this.onConnected(callback),
      MessagesDataService.onError
    );
  }

  getMessagesCount() {
    return this.http.get(`/v1/messages/${this.customer.id}/count?status=NEW_CATALOGUE`);
  }

  getMessagesStatus() {
    return this.http.get(`/v1/messages/${this.customer.id}/status?appName=CATALOGUE`);
  }
}

export { MessagesDataService };
